/**
 * Product Search System Types for v2v2 SWFL Farmers Market Application
 */

export type SearchResultType = 'product' | 'vendor' | 'market';

export interface SearchResult {
  type: SearchResultType;
  id: string;
  name: string;
  slug: string;
  description: string;
  category?: string;
  subcategory?: string;
  location?: string;
  city?: string;
  county?: string;
  seasonalNote?: string;
  vendorType?: string[];
  score: number;
  highlights?: { field: string; matchedText: string }[];
  imageUrl?: string;
  tags?: string[];
  isFeatured?: boolean;
  verified?: boolean;
}

export interface SearchFilters {
  categories?: string[];
  seasons?: string[];
  locations?: string[];
  vendorTypes?: string[];
  priceRange?: { min?: number; max?: number };
  hasUPick?: boolean;
  isOrganic?: boolean;
  isFeatured?: boolean;
}

export interface SearchOptions {
  query: string;
  filters?: SearchFilters;
  limit?: number;
  offset?: number;
  fuzzy?: boolean;
}

export interface SearchState {
  query: string;
  results: SearchResult[];
  isLoading: boolean;
  filters: SearchFilters;
  totalCount: number;
  error: string | null;
}

export interface UseSearchReturn {
  query: string;
  setQuery: (query: string) => void;
  results: SearchResult[];
  isLoading: boolean;
  isIndexBuilt: boolean;
  filters: SearchFilters;
  setFilters: (filters: SearchFilters) => void;
  updateFilter: <K extends keyof SearchFilters>(key: K, value: SearchFilters[K]) => void;
  clearSearch: () => void;
  clearFilters: () => void;
  totalCount: number;
  groupedResults: {
    products: SearchResult[];
    vendors: SearchResult[];
    markets: SearchResult[];
  };
  filterOptions: {
    categories: string[];
    seasons: string[];
    locations: string[];
  };
  activeFilterCount: number;
  error: string | null;
}

export interface SearchIndexEntry {
  type: SearchResultType;
  id: string;
  name: string;
  slug: string;
  description: string;
  searchableText: string;
  category?: string;
  subcategory?: string;
  tags?: string[];
  seasonalMonths?: string[];
  vendorIds?: string[];
  location?: {
    city?: string;
    county?: string;
    address?: string;
  };
  vendorType?: string[];
  score?: number;
}

export interface SearchSuggestion {
  text: string;
  type: SearchResultType;
  category?: string;
}

export const SEASON_MONTHS: Record<string, string[]> = {
  'spring': ['March', 'April', 'May'],
  'summer': ['June', 'July', 'August'],
  'fall': ['September', 'October', 'November'],
  'winter': ['December', 'January', 'February'],
  'year-round': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
};

export const SWFL_LOCATIONS = [
  { id: 'fort-myers', name: 'Fort Myers' },
  { id: 'naples', name: 'Naples' },
  { id: 'cape-coral', name: 'Cape Coral' },
  { id: 'bonita-springs', name: 'Bonita Springs' },
  { id: 'estero', name: 'Estero' },
  { id: 'sanibel-captiva', name: 'Sanibel & Captiva' },
  { id: 'marco-island', name: 'Marco Island' },
  { id: 'punta-gorda', name: 'Punta Gorda' },
];
